import "./App.css";
import { Box } from "@chakra-ui/react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import LoginForm from "./pages/Login";
import SignupForm from "./pages/Signup";
import RatingForm from "./components/Ratings";
import AdminDashboard from "./pages/Approve";
import FeedbackList from "./components/FeedbackList";
import EmailsContacted from "./components/EmailsContacted";
import Nav from "./components/Nav";
import LogoOnlyNav from "./components/LogoOnlyNav";
import auth from "./utils/auth";
import FeedbackForm from "./components/Feedbackform";
import OTPValidation from "./pages/OTP";

const ProtectedRoute = ({ children, requiredRoles }) => {
  const loggedIn = auth.loggedIn();
  const userRole = loggedIn ? auth.getUser().role : null;

  console.log("Logged In:", loggedIn); // Log if user is logged in
  console.log("User Role:", userRole); // Log the user role

  if (!loggedIn) {
    return <Navigate to="/login" replace />;
  }
  if (requiredRoles && !requiredRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default function App() {
  const location = useLocation();
  const loggedIn = auth.loggedIn();
  const PUBLIC_NAV_PREFIXES = ["/login", "/signup", "/feedback-form", "/otp"];

  const showLogoNav =
    !loggedIn ||
    PUBLIC_NAV_PREFIXES.some((p) => location.pathname.startsWith(p));

  return (
    <>
      {showLogoNav ? <LogoOnlyNav /> : <Nav />}
      <Box pt={showLogoNav ? "0px" : { base: "170px", md: "115px" }}>
        <Routes>
          <Route
            path="/"
            element={
              loggedIn ? (
                auth.getUser().role === "admin" ? (
                  <Navigate to="/feedback-list" replace />
                ) : (
                  <Navigate to="/rating" replace />
                )
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route path="/feedback-form" element={<FeedbackForm />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/signup" element={<SignupForm />} />
          <Route path="/rating" element={<RatingForm />} />

          {/* Admin and Superuser routes */}
          <Route
            path="/approve"
            element={
              <ProtectedRoute requiredRoles={["admin", "superuser"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback-list"
            element={
              <ProtectedRoute requiredRoles={["admin", "superuser"]}>
                <FeedbackList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/emails"
            element={
              <ProtectedRoute requiredRoles={["admin", "superuser"]}>
                <EmailsContacted />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/otp" element={<OTPValidation />} />
        </Routes>
      </Box>
    </>
  );
}
